<template>
	<div class="input-group d-flex justify-content-between align-items-center is-size-5 py-1 px-1">
		<label :for="value" class="flex-grow-1 text-left"><slot></slot></label>
		<input class="focus-outline-yellow" type="radio" :id="value" :name="name" :value="value" v-model="gradeLevel" @click="uncheck">
	</div>
</template>

<script>
	import { $window } from '@/windowDimensions.js'

	export default {
		props: ['name', 'value'],
		computed: {
			windowWidth() { return $window.width },
			gradeLevel: {
				get() { return this.$store.state.search.filters.gradeLevel },
				set(value) { // setter only gets called if value passed is different, so we need an uncheck method
					this.$store.commit('updateGradeLevel', value)
					this.$store.dispatch('basicSearch')
					this.scrollTop()
				}
			}
		},
		methods: {
			uncheck(e) {
				if (e.target.id === this.gradeLevel) {
					this.$store.commit('updateGradeLevel', '')
					this.$store.dispatch('basicSearch')
					this.scrollTop()
				} else {
					this.triggerAnalytics(e.target.id) // only trigger analytics if applying filter (not removing)
				}
			},
			scrollTop() {	// scroll up on smaller screens when filters is fixed on screen
				if (this.windowWidth < 1216) {
					document.documentElement.scrollIntoView()
				}
			},
			triggerAnalytics(label) {
				gtag('event', 'grade_level_selected', {
					'event_category': 'sidebar_interaction',
					'event_label': label
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.input-group:hover {
		cursor: pointer;
		background-color: #7c6493;
	}
	label:hover,
	input:hover {
		cursor: pointer;
	}
</style>
